import { defineComponent as _defineComponent } from 'vue'
import {
  getNewbieprivRule,
  editNewbieprivRule,
  getNewbieprivList,
  putNewbiepriv,
} from '@/api/operation/newbiepriv';
import NEditor from '@/component/NForm/NEditor/NEditor.vue';
import { computed, onMounted, ref, watch } from 'vue';
import NModel from '@/component/NModel/NModel.vue';
import { useForm } from '@/util/useForm';
import { getSimpleCategory } from '@/api/ware/category';
import { formatDate } from '@/util/global';
import EditableCell from '@/component/editable-cell.vue';
import NCascader from '@/component/NForm/NCascader/NCascader.vue';
import ProductSelector from './components/ProductSelector.vue';
import ModalItem from '@/component/ModalItem/ModalItem.vue';
import moment from 'moment';
import NewBieprivAddPrice from './components/NewBieprivAddPrice.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'NewBiepriv',
  setup(__props) {

const visible = ref(false)
const ware_category_list = ref<any[]>([]);
onMounted(() => {
  (async () => {
    const res = await getSimpleCategory();
    res.unshift({ id: 0, name: '全部' });
    ware_category_list.value = res;
  })();
  queryRule();
  query();
});
const loading = ref(false);
const dataSource = ref<any>([]);
const editorData = ref<string>('');
const editStatus = ref<boolean>(true);
const initValue = ref<string>('');
const queryParams = ref();
const form = useForm();
const selectedRowKeys = ref<any[]>([]); // 选中
const pagination = ref<{
  current: number;
  total: number;
  pageSize: number;
  showTotal: () => string;
}>({
  current: 1,
  total: 0,
  pageSize: 20,
  showTotal: () => `共0条, 每页20条`,
});
const isSelectAll = computed(()=>{
  const maxLength = dataSource.value.length || 0
  const selectLength  =selectedRowKeys.value.length ||0
  if(maxLength){
    return Boolean(selectLength > 0 && selectLength == maxLength)
  }else{
    return false
  }
})
function onSelectChange(selectedRow) {
  selectedRowKeys.value = selectedRow;
}
function onSelectAll() {
  const maxLength = dataSource.value.length || 0
  const selectLength  =selectedRowKeys.value.length ||0
  if (selectLength == maxLength) {
    selectedRowKeys.value = [];
  } else {
    selectedRowKeys.value = dataSource.value.map(i => i.id);
  }
}
async function query(params = queryParams.value) {
  dataSource.value = [];
  loading.value = true;
  const res: any = await getNewbieprivList(params);
  loading.value = false;
  dataSource.value = res.detail;
  pagination.value = {
    current: Number(res.current),
    total: Number(res.total),
    pageSize: Number(res.limit),
    showTotal: () => `共${res.total}条, 每页${res.limit}条`,
  };
  onSelectChange([])
}
const addData = ref()
async function add(addRecords: { price?: number; product_id?: number; sort?: number }[]) {
  visible.value = true
  addData.value = addRecords
  // const res = await putNewbiepriv({
  //   add: addRecords,
  // });
  // query();
}
async function onAdd(value){
  visible.value=false
  const res = await putNewbiepriv({
    add: value.map(item=>{
      return  {
        price:item.new_price*100,
        sort:0,
        product_id:item.id
      }
    }),
  });
  query();
}
function onEdit() {
  editStatus.value = false;
}
async function handleMenuClick(onLoading,callback) {
  console.log(selectedRowKeys.value);

  if (selectedRowKeys.value.length > 0) {
    console.log(selectedRowKeys.value);
    onLoading?.()
    const res = await putNewbiepriv({
      del: selectedRowKeys.value,
    });
    onLoading?.()
    callback?.()
    if (res) {
      query();
    }
  }
}
async function handleSortChange({ id, price, sort }: { id: number; price: number; sort: number }) {
  const res = await putNewbiepriv({
    edit: [
      {
        id,
        sort,
        price,
      },
    ],
  });
  if (res) {
    query();
  }
}
async function onRemoveProduct(record) {
  const res = await putNewbiepriv({
    del: [record.id],
  });
  if (res) {
    query();
  }
}
async function onSave() {
  if (editorData.value == initValue.value) {
    //判断当次保存是否需要更新
    editStatus.value = true;
    return;
  }

  if (await editNewbieprivRule(editorData.value)) {
    //保存默认数据，用于下次保存时判断是否需要更新
    // eslint-disable-next-line require-atomic-updates
    initValue.value = editorData.value || '';
    editStatus.value = true;
    queryRule();
  }
}
// 清除搜索条件
function clear() {
  form.value.resetFields();
  queryParams.value = {};
  queryGoods();
}
async function queryRule() {
  const res = await getNewbieprivRule();
  initValue.value = res?.rule || '';
  editorData.value = res?.rule || '';
}
function onTableChange({ current, pageSize }, filters, { order, columnKey }) {
  console.log(pageSize);

  queryParams.value = { ...queryParams.value, current, limit: pageSize };
  if (!order) {
    queryParams.value = {
      ...queryParams.value,
      [columnKey + '_sort']: undefined,
    };
  } else if (order == 'descend') {
    queryParams.value = {
      ...queryParams.value,
      [columnKey + '_sort']: columnKey + '_desc',
    };
  } else if (order == 'ascend') {
    queryParams.value = {
      ...queryParams.value,
      [columnKey + '_sort']: columnKey + '_asc',
    };
  }
  query();
}
function queryGoods() {
  const params = form.value.getFormValue();
  params.start_time = params?.time?.[0] ? moment( moment(new Date(params?.time?.[0]*1000)).format('YYYY-MM-DD 00:00:00')).format('X'):undefined
  params.end_time = params?.time?.[1] ? moment( moment(new Date(params?.time?.[1]*1000)).format('YYYY-MM-DD 23:59:59')).format('X'):undefined
  params.time = undefined
  for (const col in params) {
    !params[col] && (params[col] = undefined);
  }  
  queryParams.value = { ...params };
  query();
}

return { __sfc: true,visible, ware_category_list, loading, dataSource, editorData, editStatus, initValue, queryParams, form, selectedRowKeys, pagination, isSelectAll, onSelectChange, onSelectAll, query, addData, add, onAdd, onEdit, handleMenuClick, handleSortChange, onRemoveProduct, onSave, clear, queryRule, onTableChange, queryGoods, NEditor, NModel, formatDate, EditableCell, NCascader, ProductSelector, ModalItem, NewBieprivAddPrice }
}

})